export const watchers = [
];

export default {
    watchers,
};
